export default function FunTile(props) {
    return <node {...props.data}></node>
}
  